<template>
  <div class="select-wrap" :class="{ error: type === 'error' || hasError }">
    <el-select
      v-model="customerName"
      filterable
      clearable
      :disabled="disabled"
      :placeholder="placeholder"
      @change="change"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.display_text"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <label v-if="show_floating_label" :class="customerName==''?'':'risen'">{{ placeholder }}</label>
  </div>
</template>

<script>
export default {
  name: "NewSelectWrapper",
  props: {
    value: {

    },
    type: {
      type: String,
      default: "normal",
    },
    placeholder: {
      type: String,
    },
    notFound: {
      type: String,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show_floating_label: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      customerName: "",
      options: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.customerName = this.value
  },
  watch: {
    value(){
      this.customerName = this.value
    }
  },
  methods: {
    getList() {
      axios.get(window.base + '/library?type='+this.type+'&lang=en').then(response => {
        this.options = response.data
      })
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        let opt = {
          page: 1,
          rows: 50,
          storeId: "0001",
          customerName: query,
        };
        clientlist(opt).then((res) => {
          console.log(res);
          this.loading = false;
          this.options = res.data.resultList;
        });
      } else {
        this.options = [];
      }
    },
    change() {
      this.$emit('change', this.customerName)
    }
  },
};
</script>

<style lang="less">
.select-wrap {
  display: inline-block;
  position: relative;
}
.error {
  .el-input__inner {
    border-color: red!important;
  }
}
.select-wrap input.el-input__inner:placeholder-shown{
  padding-top: 0;
  font-size: 14px;
}
</style>

<style scoped>
label{
	opacity: 0;
	font-size: 14px;
	margin-top: -2.5rem;
	margin-left: 1.125em;
	transition: all 0.5s;
	opacity: 0;
  position: absolute;
}
  label.risen{
	font-size: 10px;
	margin-top: -.5em;
	position: absolute;
	margin-top: -3.25rem;
	position: absolute;
	margin-left: 1.5em;
	opacity: .4;
  left: 0;
  top: 4px;
  margin-top: 0;
	transition: all 0.5s;
}


/* .tabs-common input,
.tabs-common select{
	padding-top: 1rem;
	transition: all .5s;
}
.tabs-common input:placeholder-shown,
.tabs-common select[data-chosen=""]{
	padding-top: .5rem;
} */
</style>